import { Injectable } from '@angular/core';

@Injectable()
export class SelectionHandler {
  disableSelect(el) {
    if (el.addEventListener) {
      el.addEventListener('mousedown', this.disabler, 'false');
    } else {
      el.attachEvent('onselectstart', this.disabler);
    }
  }

  enableSelect(el) {
    if (el.addEventListener) {
      el.removeEventListener('mousedown', this.disabler, 'false');
    } else {
      el.detachEvent('onselectstart', this.disabler);
    }
  }

  disabler(e) {
    if (e.target && e.target.tagName
      && e.target.tagName.toLowerCase() === 'input') {
      return;
    }

    if (e.preventDefault) {
      e.preventDefault();
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/selection-handler.service.ts